import { getPropertyId } from 'FormsUI/utils/PropertiesUtils';
import { getFormFieldLabel } from 'FormsUI/utils/FormFieldsUtils';
export const getTranslatedProperty = (formFields, property, propertyId, formLanguage) => {
  if (!property.originalLabel) {
    property.originalLabel = property.label;
  }
  property.label = formFields[propertyId] ? formFields[propertyId].label : getFormFieldLabel(property.originalLabel, formLanguage);
  return property;
};
export const getWithOriginalAndUpdatedLabel = (formFieldsByPropertyId, formLanguage) => contactProperty => getTranslatedProperty(formFieldsByPropertyId, contactProperty, getPropertyId(contactProperty), formLanguage);